var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row history-body"},[_c('div',{staticClass:"col-12"},[_c('history-search-form',{attrs:{"filters":_vm.filters}}),_c('history-results-list',{attrs:{"ordersList":_vm.historyOrdersList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }